module.exports = __webpack_public_path__ + "static/cp-ctnet-badge-color-65b0fcba232eb99d42a2fd6b63808345.svg";